import React, { useState, useEffect } from 'react';

import { Row, Col, Form } from 'react-bootstrap';

import styles from './epstEvaluation.module.scss';
import QuestionMedia from 'pages/certifications/epst/wizard/section-form/QuestionMedia';
import QuestionPassage from 'pages/certifications/epst/wizard/section-form/QuestionPassage';

const Questions = ({ questionData }) => {
	const { question_id, question, answers, selected_option, instruction, image, passage, audio, points  } = questionData;

	const earnedPoints =
	selected_option && answers.find(a => a.option === selected_option)?.is_correct === 1
		? points
		: 0;

	return (
		<div className={styles.container}>
			<Row className={styles.instruction}>
				<Col>{instruction}</Col>
			</Row>
			<Row className={`${styles.question} mt-3`}>
				<Col><p className={styles.questionText}><strong>{question}</strong></p></Col>
			</Row>
			<QuestionPassage passage={passage} />
			<QuestionMedia image={image} audio={audio} />
			<Row className="mt-3">
				{answers.map((answer, i) => (
					<Col key={i} md={3}>
						<Form.Check type="radio" id={`answer-${question_id}-${answer.option}`}>
							<Form.Check.Input
								type="radio"
								name={`answer-${question_id}`}
								value={answer.option}
								defaultChecked={selected_option === answer.option}
								isValid={selected_option === answer.option && answer.is_correct === 1}
								isInvalid={selected_option === answer.option && answer.is_correct === 0}
								style={{ pointerEvents: 'none' }}
							/>
							<Form.Check.Label
								style={{ pointerEvents: 'none' }}
								className={
									selected_option === answer.option
										? answer.is_correct === 1
											? 'correct-answer'
											: 'incorrect-answer'
										: ''
								}>
								{answer.option}
							</Form.Check.Label>
						</Form.Check>
					</Col>
				))}
			</Row>
			<Row className="mt-4 justify-content-end text-end">
				<Col xs="auto">
					<p><strong>Puntos obtenidos:</strong> {earnedPoints}</p>
				</Col>
			</Row>
			
			
		</div>
	);
};

export default Questions;